
import API from '../config/api.js'

export const CommonService = {    
  
    getRegions() {
        return API.get('api/region/list');
    },

    getInternationalThemes() {
        return API.get('api/international-theme/list');
    },

    getGovernorThemes() {
        return API.get('api/governor-theme/list');
    },

    getOfficeRoles(search) {
        return API.get(`api/office-role/list/se=${search}`);
    },

    deleteDocument(id) {
        return API.delete(`api/document/delete/${id}`);
    },

    getMemberTypes() {
        return API.get('api/member/type/list');
    },

    getUserRoleClubs(search) {
        return API.get(`api/user/role/club-list/se=${search}`);
    },

    getRegionZones(id) {
        return API.get(`api/region/zone/${id}`);
    },

    clubCreate(data){
        return API.post(`api/club/create`, data);
    },

    clubUpdate(id, data){
        return API.post(`api/club/update/${id}`, data);
    },

    getClubList(search){
        return API.get(`api/user/role/club-list/se=${search}`);
    },

    zoneCreate(data){
        return API.post(`api/zone/create`, data);
    },

    zoneUpdate(id, data){
        return API.post(`api/zone/update/${id}`, data);
    },

     getZoneList(search, page=1){
        return API.get(`api/zone/list/se=${search}?page=${page}`);
    },

    

    getClubInfo(id) {
        return API.get(`api/club/info/${id}`);
    },

    getZoneInfo(id) {
        return API.get(`api/zone/info/${id}`);
    },

    

    getAllRegions() {
        return API.get(`api/region/all/list`);
    },

    getClubPoints() { 
        return API.get(`api/club/points`);
    },

    getMembersByOfficeRoleCode(roleCode) { 
        return API.get(`api/office-member/${roleCode}/list`);
    }

    

    
    

    
    


    

   

}



